import React from "react";
import { SvgXml } from "react-native-svg";
import { resolveNativeIconSize } from "@xsolla/xui-primitives-core";
import type { CurrencyIconInternalProps } from "./types";

export const BaseIcon: React.FC<CurrencyIconInternalProps> = ({
  variant = "colored",
  size = 24,
  color = "currentColor",
  coloredContent,
  monoContent,
  style,
  testID,
  "aria-label": ariaLabel,
}) => {
  const svgContent = variant === "colored" ? coloredContent : monoContent;
  const resolvedSize = resolveNativeIconSize(size, 24);

  return (
    <SvgXml
      xml={svgContent}
      width={resolvedSize}
      height={resolvedSize}
      color={color}
      style={style}
      testID={testID}
      accessible={!!ariaLabel}
      accessibilityLabel={ariaLabel}
    />
  );
};
